var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.product)?_c('product-element',{attrs:{"product":_vm.product}}):_c('div',[_vm._v(" Document Locked ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }